import { memo, useEffect, useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { useGetLivePoints } from '../../../hooks/queries/lives/lives/use-get-live-points'
import { useGetMultiLiveTrophySumAll } from '../../../hooks/queries/lives/lives/use-get-multi-live-trophy-sum-all'
import { useGlobalStore } from '../../../store/global-store'
import type { TypeLive } from '../../../types/lives/live'
import { useUpdateLivePoints } from './use-update-live-points'

export const TrophyIcon = memo(() => {
  useUpdateLivePoints()

  const { liveId, typeLive } = useGlobalStore(
    useShallow((state) => ({
      liveId: state.liveId,
      typeLive: state.typeLive,
      token: state.token,
    })),
  )

  const isMultiLive = typeLive?.includes('multi')

  const { liveTrophy } = useGetMultiLiveTrophySumAll(
    typeLive as TypeLive,
    isMultiLive,
  )

  const { live: livePoints } = useGetLivePoints(liveId as number, !isMultiLive)

  const { points, setLivePoints } = useGlobalStore(
    useShallow((state) => ({
      points: state.livePoints,
      setLivePoints: state.setLivePoints,
    })),
  )

  useEffect(() => {
    if (isMultiLive) {
      setLivePoints(liveTrophy?.quantity ?? 0)
    }

    if (!isMultiLive) {
      setLivePoints(livePoints?.points ?? 0)
    }
  }, [liveTrophy, livePoints, isMultiLive, setLivePoints])

  const pointsFormated = useMemo(
    () =>
      Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1,
      }).format(points),
    [points],
  )

  const isAndroid = navigator.appVersion.includes('Android')

  return (
    <div className="w-screen h-screen flex items-center justify-center">
      <span
        className="text-white font-bold"
        style={{
          fontSize: isAndroid ? '1px' : '10px',
        }}
      >
        {pointsFormated}
      </span>
    </div>
  )
})
